export default __webpack_public_path__ + "static/media/no_data_available.25e4aab1.svg";